import "./style.css";
import { state } from "./state";
import { byId } from "./dom";
import { initFuse } from "./search";
import { renderAll, renderGrid, renderFilters } from "./render";
import { parseHashAndRender, clearSelection } from "./router";
import { syncViewToggleButtons } from "./grid";
import type { Index } from "./model";

function bindUI(): void {
  const search = byId<HTMLInputElement>("search");
  search.addEventListener("input", () => {
    state.search = search.value;
    renderGrid();
  });

  byId("view-toggle")
    .querySelectorAll<HTMLButtonElement>("button")
    .forEach((btn) => {
      btn.addEventListener("click", () => {
        state.view = btn.dataset.view as "assets" | "prefabs";
        syncViewToggleButtons();
        state.filters.kinds.clear();
        state.filters.categories.clear();
        state.filters.tags.clear();
        state.selectedAsset = null;
        state.selectedPrefab = null;
        clearSelection();
        renderAll();
      });
    });

  window.addEventListener("hashchange", parseHashAndRender);
  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape") clearSelection();
  });
}

async function boot(): Promise<void> {
  const grid = byId("grid");
  try {
    const res = await fetch("./index.json", { cache: "no-cache" });
    if (!res.ok) throw new Error(`fetch index.json: HTTP ${res.status}`);
    const index = (await res.json()) as Index;
    if (typeof index.schema_version !== "number") {
      throw new Error("index.json missing schema_version");
    }
    state.index = index;
    initFuse();
    renderFilters();
    bindUI();
    parseHashAndRender();
  } catch (e) {
    const msg = e instanceof Error ? e.message : String(e);
    grid.innerHTML = `<div class="error">failed to load index.json: ${msg}</div>`;
    console.error(e);
  }
}

void boot();
